import React, {Component} from 'react';

class IccGroup extends Component {
  renderValue(number = null) {
    return number === null ? '' : number.toFixed(2);
  }

  renderValues(values) {
    const orderCycle = values.orderCycle || 0;
    const leadTime = values.leadTime || 0;
    const safetyStockLeadTime = values.safetyStockLeadTime || 0;
    const safetyStockMad = values.safetyStockMad || 0;
    const sum = this.renderValue(
      orderCycle + leadTime + safetyStockLeadTime + safetyStockMad
    );

    return (
      <tr>
        <td>{this.renderValue(values.orderCycle)}</td>
        <td>{this.renderValue(values.leadTime)}</td>
        <td>{this.renderValue(values.safetyStockLeadTime)}</td>
        <td>{this.renderValue(values.safetyStockMad)}</td>
        <td className='bold-text'>{sum || 0}</td>
      </tr>
    );
  }

  render() {
    const {header, calculated, manual, group} = this.props;

    return (
      <table className={`group ${group}`}>
        <thead>
          <tr>
            <th colSpan='5' className='labels bold-text'>
              {header}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>O/C</td>
            <td>L/T</td>
            <td>SS L/T</td>
            <td>SS MAD</td>
            <td>SUMA</td>
          </tr>
          {this.renderValues(manual)}
          {this.renderValues(calculated)}
        </tbody>
      </table>
    );
  }
}

export default IccGroup;
